var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isOpen)?_c('my-nav'):_vm._e(),(_vm.isOpen)?_c('router-view',{staticClass:"container",attrs:{"name":"home"},on:{"changeView":_vm.changeView,"getText":_vm.getText}}):_vm._e(),(!_vm.isOpen)?_c('router-view',{attrs:{"name":"read","textObj":_vm.html},on:{"changeView":_vm.changeView}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }